export const DEFAULT_COLUMN = 'cromai_name'
